import * as React from "react";

import "./photo-integration-auth.scss";

import {consumeContext}  from "@Common/react/context";
import {ComponentLink,
        makeChain}       from "@Common/react/cst2";
import {Load2}           from "@Common/react/load2";
import {LoadingSpinner}  from "@Common/ui-components/photo-dashboard/components/loading-spinner";
import {parseUrlQuery}   from "@Common/utils/parse-url-query";
import {faX,
        faLink}          from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export const PhotoIntegrationAuth = ({
    location
}:{
    location: Location
}) => (
    makeChain<JSX.Element>()

    .then(...consumeContext("apis"))

    // authenticate against the oauth service
    .then("loaderAuth", ({apis}, next:ComponentLink<typeof Load2<boolean>>) => Load2({
        fetch: async () => {

            const query = parseUrlQuery(location.search) ?? {};
            if (!query.service || !query.code) return false;

            const authResponse = await apis.next.gallery.integrations.generateToken({
                serviceName: query.service,
                authCode: query.code,
                codeVerifier: query.code_verifier
            });
            if (!authResponse?.accessToken || !authResponse?.loginUserId) return false;

            const loginResponse = await apis.next.gallery.integrations.insert({
                serviceName: query.service,
                accessToken: encodeURIComponent(authResponse.accessToken),
                refreshToken: encodeURIComponent(authResponse.refreshToken),
                loginUserId: authResponse.loginUserId,
            });
            if (loginResponse?.statusCode) return false;

            return true;

        },
        captureException: true,
        next,
    }))

    // render the component
    .then(({loaderAuth}) => (
        <div className="photo-integration-auth-57a">
            {(loaderAuth?.loading) ? (
                <LoadingSpinner text="Saving data…"/>
            ) : (setTimeout(() => {
                if (loaderAuth.value) localStorage.setItem("oauthCompleted", "true");
                window.close();
            }, 3000)) && (
                !loaderAuth.value ? <>
                    <div className="icon-circle error">
                        <FontAwesomeIcon icon={faX}/>
                    </div>
                    <h2>There was a problem.</h2>
                    <h2>Please try again.</h2>
                    <h3>Closing window…</h3>
                </> : <>
                    <div className="icon-circle success">
                        <FontAwesomeIcon icon={faLink}/>
                    </div>
                    <h2>Sign In was successful.</h2>
                    <h3>Closing window…</h3>
                </>
            )}
        </div>
    ))

    .run()

);
